import React from 'react';
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
} from 'react-router-dom';

import PageNotFound from '~/commons/components/PageNotFound.jsx';
import { permittedLinks } from '../layout';
import { PageAdmins, PageAdmin } from '../pages/admins';
import {
  PageDepartments,
  PageDepartment,
} from '../pages/departments';
import {
  PageCustomers,
  PageCustomer,
} from '../pages/customers';
import { PageRole, PageRoles } from '../pages/roles';

import { PageSelf } from '../pages/self';

const RouteUsers = () => {
  const { path } = useRouteMatch();

  const { links = [] } = permittedLinks.find(
    ({ segment }) => segment === 'users',
  ) || {};

  const routers = [
    { path: `${path}/admins`, router: <PageAdmins /> },
    { path: `${path}/admins/:_id`, router: <PageAdmin /> },
    { path: `${path}/departments`, router: <PageDepartments /> },
    { path: `${path}/departments/:_id`, router: <PageDepartment /> },
    { path: `${path}/customers`, router: <PageCustomers /> },
    { path: `${path}/customers/:_id`, router: <PageCustomer /> },
    { path: `${path}/roles`, router: <PageRoles /> },
    { path: `${path}/roles/:_id`, router: <PageRole /> },
  ];

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={links[0]?.to || `${path}/self`} />
      </Route>
      {
        routers.reduce((acc, cur) => {
          const cleanPath = cur.path.replace(/\/:.+/g, '');
          const found = links.find(({ to }) => to === cleanPath);
          if (!found) return acc;

          return [...acc, (
              <Route key={cur.path} path={cur.path} exact>
                {cur.router}
              </Route>
          )];
        }, [])
      }
      <Route exact path={`${path}/self`}>
        <PageSelf />
      </Route>
      <Route path={'*'}>
        <PageNotFound />
      </Route>
    </Switch>
  );
};

export default RouteUsers;
